import TicketSaleService from './../services/ticket-sale.service'
import { busSeatSelectionConstants } from '../constants/bus-seat-selection.constants'
import { toastActions } from '@actions'
import { Creators as TicketSaleCreators } from '../ducks/ticket-sale/ticket-sale'

const loadBusSeatsGoing = (params) => async (dispatch) => {
	const { data, success } = await TicketSaleService.getBusData(
		params,
		busSeatSelectionConstants.LOAD_BUS_SEATS_GOING
	)

	if (!success) {
		throw new Error()
	} else {
		dispatch({
			payload: data.busSeats.filter(
				({ number, available }) => number !== '' && available
			),
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_GOING,
		})

		dispatch(TicketSaleCreators.setExtraDataGoing(data))

		dispatch(
			TicketSaleCreators.setTripEmbarcationGoing({
				boardingTerminal: data.boardingTerminal,
				disembarkingTerminal: data.disembarkingTerminal,
			})
		)
	}
}

const loadBusSeatsGoingConexao = (params) => async (dispatch) => {
	const { data, success } = await TicketSaleService.getBusData(
		{
			...params,
			busCompany: params.enterprise,
		},
		busSeatSelectionConstants.LOAD_BUS_SEATS_GOING
	)

	if (!success) {
		throw new Error()
	} else {
		let seatMap = data.busSeats.map((busSeat) => ({
			...busSeat,
			dataViagem: params.Departure,
		}))

		dispatch({
			payload: seatMap.filter(
				({ number, available }) => number !== '' && available
			),
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_GOING,
		})

		dispatch(TicketSaleCreators.setExtraDataGoing(data))

		dispatch(
			TicketSaleCreators.setTripEmbarcationGoing({
				boardingTerminal: data.boardingTerminal,
				disembarkingTerminal: data.disembarkingTerminal,
			})
		)
	}
}

const loadBusSeatsReturnConexao = (params) => async (dispatch) => {
	const { data } = await TicketSaleService.getBusData(
		{
			...params,
			busCompany: params.enterprise,
		},
		busSeatSelectionConstants.LOAD_BUS_SEATS_GOING
	)

	if (!data) {
		dispatch(
			toastActions.danger({
				message:
					'Não foi possível obter as poltronas, tente novamente mais tarde.',
			})
		)
		return
	}

	let seatMap = data.busSeats.map((busSeat) => {
		return { ...busSeat, dataViagem: params.Departure }
	})

	dispatch({
		payload: seatMap.filter(
			({ number, available }) => number !== '' && available
		),
		type: busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN,
	})

	dispatch(TicketSaleCreators.setExtraDataReturn(data))

	dispatch(
		TicketSaleCreators.setTripEmbarcationReturn({
			boardingTerminal: data.boardingTerminal,
			disembarkingTerminal: data.disembarkingTerminal,
		})
	)
}

const loadBusSeatsReturn = (params) => (dispatch) => {
	return TicketSaleService.getBusData(
		params,
		busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN
	).then(({ data }) => {
		if (!data) {
			dispatch(
				toastActions.danger({
					message:
						'Não foi possível obter as poltronas, tente novamente mais tarde.',
				})
			)
			return
		}

		dispatch({
			payload: data.busSeats.filter(
				({ number, available }) => number !== '' && available
			),
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN,
		})

		dispatch(TicketSaleCreators.setExtraDataReturn(data))

		dispatch(
			TicketSaleCreators.setTripEmbarcationReturn({
				boardingTerminal: data.boardingTerminal,
				disembarkingTerminal: data.disembarkingTerminal,
			})
		)
	})
}

const selectBusSeatGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SELECT_BUS_SEAT_GOING,
	})
	dispatch(TicketSaleCreators.setPriceGoing(payload.price))
}

const deselectBusSeatGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.DESELECT_BUS_SEAT_GOING,
	})
}

const selectBusSeatReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SELECT_BUS_SEAT_RETURN,
	})
	dispatch(TicketSaleCreators.setPriceReturn(payload.price))
}
const deselectBusSeatReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.DESELECT_BUS_SEAT_RETURN,
	})
}

const setTotalSeatsGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_TOTAL_SEATS_GOING,
	})
}

const setOrdemViagemIda = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_ORDEM_VIAGEM_IDA,
	})
}

const getOrdemViagemIda = () => ({
	type: busSeatSelectionConstants.GET_ORDEM_VIAGEM_IDA,
})

const setTotalSeatsReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_TOTAL_SEATS_RETURN,
	})
}

const reset = () => ({
	type: busSeatSelectionConstants.RESET,
})

const getNumberOfPassengers = () => ({
	type: busSeatSelectionConstants.GET_NUMBER_OF_PASSENGERS,
})

export const busSeatSelectionActions = {
	reset,
	loadBusSeatsGoing,
	loadBusSeatsReturn,
	loadBusSeatsGoingConexao,
	loadBusSeatsReturnConexao,
	selectBusSeatGoing,
	setTotalSeatsGoing,
	selectBusSeatReturn,
	setTotalSeatsReturn,
	deselectBusSeatGoing,
	deselectBusSeatReturn,
	getNumberOfPassengers,
	setOrdemViagemIda,
	getOrdemViagemIda,
}
